module.exports = "/assets/71c282b6cb05fc923ce1823706a9fa1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/car.svg
// module id = 3325
// module chunks = 0